import React, {useState} from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

// import DriverSearchInput from "../DriverSearchInput";
import UsersTable from './UsersTable';
import { Box } from '@mui/material';

function UsersTab(props) {
    const [searchValue, setSearchValue] = useState("");
    
    const updateSearchValue = (value) => {
      setSearchValue(value);
    }


  return (
    <div>
      <Box sx={{p:0}}>
        <UsersTable props={props} />
      </Box>
    </div>
  );
}

export default UsersTab;
